import React, { useState } from 'react';
import PraxisList from '../components/praxis/PraxisList';
import PraxisForm from '../components/praxis/PraxisForm';
import DeletePraxisDialog from '../components/praxis/DeletePraxisDialog';
import { Praxis } from '../types';

type ViewMode = 'list' | 'create' | 'edit';

const PraxisPage: React.FC = () => {
  const [viewMode, setViewMode] = useState<ViewMode>('list');
  const [selectedPraxis, setSelectedPraxis] = useState<Praxis | null>(null);
  const [praxisToDelete, setPraxisToDelete] = useState<Praxis | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleCreate = () => {
    setSelectedPraxis(null);
    setViewMode('create');
  };

  const handleEdit = (praxis: Praxis) => {
    setSelectedPraxis(praxis);
    setViewMode('edit');
  };

  const handleDelete = (praxis: Praxis) => {
    setPraxisToDelete(praxis);
  };

  const handleFormSuccess = () => {
    setViewMode('list');
    setSelectedPraxis(null);
    setRefreshTrigger(prev => prev + 1);
  };

  const handleFormCancel = () => {
    setViewMode('list');
    setSelectedPraxis(null);
  };

  const handleDeleteSuccess = () => {
    setPraxisToDelete(null);
    setRefreshTrigger(prev => prev + 1);
  };

  const handleDeleteCancel = () => {
    setPraxisToDelete(null);
  };

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Praxen</h1>
      
      {viewMode === 'list' && (
        <PraxisList
          onEdit={handleEdit}
          onDelete={handleDelete}
          onCreate={handleCreate}
          refreshTrigger={refreshTrigger}
        />
      )}

      {(viewMode === 'create' || viewMode === 'edit') && (
        <PraxisForm
          praxis={selectedPraxis}
          onSuccess={handleFormSuccess}
          onCancel={handleFormCancel}
        />
      )}

      {praxisToDelete && (
        <DeletePraxisDialog
          praxis={praxisToDelete}
          onSuccess={handleDeleteSuccess}
          onCancel={handleDeleteCancel}
        />
      )}
    </div>
  );
};

export default PraxisPage;
